import { tracked } from '@glimmer/tracking';

import FilterSortGoalCompany from 'webapp/models-custom/filter-sort/goal-company';

export default class FilterSortGoalCompanyInGrid extends FilterSortGoalCompany {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
